"use client"

import {BrowserRouter, Route, Routes} from 'react-router-dom';
import {Provider} from './components/ui/provider';
import {Flex} from "@chakra-ui/react";
import './App.css';

import LandingPage from "./pages/LandingPage";

function App() {

    return (
        <Provider>
            <BrowserRouter>
                <Flex direction="column" height="100vh">
                    <Routes>
                        <Route path='/'
                               element={<LandingPage/>}/>
                    </Routes>
                </Flex>
            </BrowserRouter>
        </Provider>
    );
}

export default App;